import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './components/redux/store';
import { ThemeProvider } from './context/ThemeContext';
import MuiThemeWrapper from './theme/MuiThemeWrapper';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <ThemeProvider>
        <MuiThemeWrapper>
          <App />
        </MuiThemeWrapper>
      </ThemeProvider>
    </Provider>
  </HelmetProvider>
);
